(ns web3.tracking.mixpanel
  (:refer-clojure :exclude [reset!])
  (:require [applied-science.js-interop :as j]))

(def mixpanel (delay (j/get js/window :mixpanel)))

(defn get-distinct-id []
  (when @mixpanel
   (.get_distinct_id ^js @mixpanel)))

(defn reset! []
  (.reset ^js @mixpanel))